import { useAuthContext } from '../store/contexts/AuthContext';

const useIdToken = () => {
  const { cognitoUser } = useAuthContext();

  return cognitoUser?.accessToken;
};

export default useIdToken;
